var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgVideoTutorial = function SvgVideoTutorial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#41A6DC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.27 16.032v3.932l3.145-1.966z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.076 25.996h14.848A3.08 3.08 0 0 0 28 22.92v-9.844A3.08 3.08 0 0 0 24.924 10H10.076A3.08 3.08 0 0 0 7 13.076v9.844a3.08 3.08 0 0 0 3.076 3.076Zm4.963-11.074a.616.616 0 0 1 .942-.522l4.921 3.077a.615.615 0 0 1 0 1.043l-4.921 3.076a.613.613 0 0 1-.942-.522v-6.152Z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5
  }))));
};

export { SvgVideoTutorial as ReactComponent };
export default __webpack_public_path__ + "2572f83e54584bac6baf32af298db283.svg";